import { OrderingBizHour, OrderingHoliday } from 'kiolyn-api';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment-timezone';
import inWorkingHoursHoliday from './CheckInWorkingHoursHoliday';
import inBizHours from './CheckInWorkingHours';
import { defaultTimezone } from '../models/Constants';

export default function validateBizHours(
  format: string,
  bizHours?: OrderingBizHour[],
  value?: string | moment.Moment,
  holidays?: OrderingHoliday[],
  timezone?: string
) {
  // If there is no value or biz hours to check then this should be valid
  // for backward compatible
  if (isEmpty(value) || (isEmpty(bizHours) && isEmpty(holidays))) {
    return null;
  }
  const date =
    typeof value === 'object'
      ? value
      : moment(value, format).tz(timezone || defaultTimezone);
  let isWorking = true;
  const [isWorkingHoursHoliday, holiday] = inWorkingHoursHoliday(
    holidays,
    date.toDate(),
    timezone
  );
  if (holiday !== undefined) {
    isWorking = isWorkingHoursHoliday;
  } else if (bizHours !== undefined) {
    [isWorking] = inBizHours(bizHours, date.toDate(), timezone);
  } else {
    return null;
  }

  if (isWorking) {
    return null;
  }
  return 'bizHours';
}
